// import React, { useEffect, useState } from "react";
// import navHeaderLogo from "../../assets/sideBar/navHeaderLogo.svg";
// import navHeaderLogoIcon from "../../assets/sideBar/navHeaderLogoIcon.svg";
// import { motion, AnimatePresence } from "framer-motion";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { useLoginUser } from "../../hooks/useLoginUser";
// import { filterNavByModuleAccess } from "../../utils/moduleAccessUtils";
// import Divider from "./Divider";

// const SidebarMenuItems = ({ menus, menusEnd }) => {
//   const [hoveredKey, setHoveredKey] = useState(null); // e.g. "top-2", "bottom-1"
//   const [tooltipDirection, setTooltipDirection] = useState("down"); // "up" | "down"
//   const [activeIndex, setActiveIndex] = useState(); // your existing active logic
//   const [activeSubLink, setActiveSubLink] = useState();
//   const location = useLocation();
//   const navigate = useNavigate();

//   // Onload set active index
//   useEffect(() => {
//     const path = location.pathname;
//     const hashPath = location.pathname + location.hash;
//     const items = [...(menus || []), ...(menusEnd || [])];

//     for (const menu of items) {
//       if (menu.link && (menu.link === path || menu.link === hashPath)) {
//         setActiveIndex(menu.title);
//         setActiveSubLink(undefined);
//         return;
//       }
//       if (menu.subMenus) {
//         for (const sub of menu.subMenus) {
//           if (sub.link && (sub.link === path || sub.link === hashPath)) {
//             setActiveIndex(menu.title);
//             setActiveSubLink(sub.link);
//             return;
//           }
//         }
//       }
//     }
//   }, [location.pathname, location.hash, menus, menusEnd]);

//   // Onload set active index end

//   const decideDirection = (el, item) => {
//     const rect = el.getBoundingClientRect();

//     // Rough tooltip height estimate: title + items + padding
//     const itemCount = item?.subMenus?.length || 0;
//     const estimatedHeight = 20 /*title*/ + itemCount * 36 /*each*/ + 24; /*pad*/

//     const spaceBelow = window.innerHeight - rect.bottom;
//     const spaceAbove = rect.top;

//     // Prefer down unless it won't fit; then go up if we have more space above
//     const needUp = spaceBelow < estimatedHeight && spaceAbove > spaceBelow;
//     setTooltipDirection(needUp ? "up" : "down");
//   };

//   const handleMouseEnter = (e, section, index, item) => {
//     decideDirection(e.currentTarget, item);
//     setHoveredKey(`${section}-${index}`);
//   };

//   const handleMouseLeave = () => setHoveredKey(null);

//   const handleMainMenu = (menu) => {
//     if (!menu.subMenus && menu.link) {
//       setActiveIndex(menu.title);
//       setActiveSubLink(undefined);
//       navigate(menu.link);
//     }
//   };

//   const renderContent = (item, index, isActive, section) => {
//     const id = `${section}-${index}`;
//     const isHovered = hoveredKey === id;

//     return (
//       <div key={id} className="w-full">
//         <div
//           className={`w-full flex flex-col items-center gap-1 py-3 group relative cursor-pointer ${
//             isActive
//               ? "bg-primary rounded-l-lg text-white"
//               : "hover:bg-primary-50"
//           }`}
//           onMouseEnter={(e) => handleMouseEnter(e, section, index, item)}
//           onMouseLeave={handleMouseLeave}
//           onClick={() => handleMainMenu(item)}
//         >
//           {/* Icon + label */}
//           <span
//             className={`material-symbols-rounded text-[24px] font-thin ${
//               isActive ? "text-white" : "text-white group-hover:text-black"
//             }`}
//           >
//             {item.icon}
//           </span>
//           <span
//             className={`text-[12px] text-center font-normal ${
//               isActive ? "text-white" : "text-white group-hover:text-black"
//             }`}
//           >
//             {item.abbrivation || item.title}
//           </span>

//           {/* Tooltip (only if subMenus) */}
//           {item.subMenus && (
//             <AnimatePresence>
//               {isHovered && (
//                 <motion.div
//                   initial={{
//                     opacity: 0,
//                     y: tooltipDirection === "up" ? 10 : -10,
//                   }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{
//                     opacity: 0,
//                     y: tooltipDirection === "up" ? 10 : -10,
//                   }}
//                   transition={{ duration: 0.2 }}
//                   className="absolute left-[100%] flex items-start rounded text-xs whitespace-nowrap z-100"
//                   style={{
//                     top: tooltipDirection === "down" ? 0 : "auto",
//                     bottom: tooltipDirection === "up" ? 0 : "auto",
//                   }}
//                 >
//                   <div className="bg-dark text-white rounded-r-lg flex flex-col p-3 min-w-[180px] max-h-[70vh] overflow-auto">
//                     <h6>{item.title}</h6>
//                     {item.subMenus?.length > 0 && (
//                       <>
//                         <Divider className="text-primary my-1 w-[70%]" />
//                         <div className="flex flex-col pt-2 ms-2">
//                           {item.subMenus.map((submenu, subKey) => (
//                             <Link
//                               key={`${id}-sub-${subKey}`}
//                               to={
//                                 submenu.link
//                                   ? submenu.link
//                                   : location.pathname + location.hash
//                               }
//                               className={`py-2 hover:text-primary ${
//                                 activeSubLink === submenu.link
//                                   ? "text-primary font-medium"
//                                   : ""
//                               }`}
//                               onClick={() => {
//                                 setActiveIndex(item.title);
//                                 setActiveSubLink(submenu.link);
//                                 setHoveredKey(null);
//                               }}
//                             >
//                               {submenu.title}
//                             </Link>
//                           ))}
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           )}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="flex flex-col gap-0 h-full">
//       <div className="flex-1">
//         {menus.map((item, index) => {
//           const isActive = activeIndex === item.title;
//           return renderContent(item, index, isActive, "top");
//         })}
//       </div>

//       {menusEnd?.map((item, index) => {
//         const isActive = activeIndex === item.title;
//         return renderContent(item, index, isActive, "bottom");
//       })}
//     </div>
//   );
// };

// const atsNavLinkData = [
//   {
//     icon: "dashboard",
//     title: "Dashboard",
//     link: "/ats/dashboard",
//     id: "dashboard",
//   },
//   {
//     icon: "group_search",
//     abbrivation: "RA",
//     title: "Research Analyst",
//     //link: "/ats/dashboard",
//     subMenus: [
//       {
//         title: "Leads",
//         link: "/ats/leads",
//         id: "leads",
//       },
//       {
//         title: "Campaigns",
//         link: "/ats/campaigns",
//         id: "campaigns",
//       },
//       {
//         title: "Prospects",
//         link: "/ats/prospects",
//         id: "prospects",
//       },
//     ],
//   },
//   {
//     icon: "host",
//     abbrivation: "BDM/AM",
//     title: "BDM/AM",
//     //link: "/ats/leads",
//     subMenus: [
//       {
//         title: "Accounts",
//         link: "ats/account-details",
//         id: "accountdetails",
//       },
//       {
//         title: "Vendors",
//         link: "/ats/vendors",
//         id: "vendors",
//       },
//       {
//         title: "Jobs",
//         link: "/ats/jobs",
//         id: "jobs",
//       },
//       {
//         title: "Pipeline Candidate",
//         link: "/ats/bdm/pipeline-candidates",
//         id: "pipelinecandidates",
//       },
//       {
//         title: "Client Submissions",
//         link: "/ats/bdm/client-submissions",
//         id: "clientsubmissions",
//       },
//       {
//         title: "Follow up / interview",
//         link: "/ats/bdm/followup-interviews",
//         id: "followupinterviews",
//       },
//       {
//         title: "Confirmed / Starts",
//         link: "/ats/bdm/confirmed-starts",
//         id: "confirmedstarts",
//       },
//       {
//         title: "Priority Leads",
//         link: "/ats/bdm/priority-leads",
//         id: "priorityleads",
//       },
//     ],
//   },
//   {
//     icon: "article_person",
//     abbrivation: "Recruitment",
//     title: "Recruitment",
//     //link: "/ats/account-details",
//     subMenus: [
//       {
//         title: "Jobs",
//         link: "/ats/recruitment/jobs",
//         id: "recruitmentjobs",
//       },
//       {
//         title: "Sourcing",
//         link: "/ats/applicants",
//         id: "applicants",
//       },
//       {
//         title: "Campaigns",
//         link: "/ats/recruitment/campaigns",
//         id: "recruitmentcampaigns",
//       },
//       {
//         title: "Internal Submissions",
//         link: "/ats/recruitment/internal-submissions",
//         id: "recruitmentinternalsubmissions",
//       },
//       {
//         title: "Interview follow-up",
//         link: "/ats/recruitment/interview-followup",
//         id: "recruitmentinterviewfollowup",
//       },
//       {
//         title: "Confirmed / Starts",
//         link: "/ats/recruitment/confirmed-start",
//         id: "recruitmentconfirmedstart",
//       },
//     ],
//   },
//   // {
//   //   icon: "badge",
//   //   abbrivation: "Bench Sales",
//   //   title: "Bench Sales",
//   //   //link: "/ats/campaigns",
//   //   subMenus: [
//   //        {
//   //       title: "Recruiters",
//   //       link: "/ats/benchsales/recruiters",
//   //       id: "benchsalesrecruiters",
//   //     },
//   //     {
//   //       title: "Candidates",
//   //       link: "/ats/benchsales/candidates",
//   //       id: "benchsaleshotlist",
//   //     },
//   //   /*  {
//   //     title: "Campaign",
//   //       link: "/ats/benchsales/campaign",
//   //       id: "benchsalescampaign",
//   //     },*/
//   //     {
//   //       title: "Jobs",
//   //       link: "/ats/benchsales/Jobs",
//   //       id: "benchsaleskultfetch",
//   //     },
//   //     {
//   //       title: "Submissions",
//   //       link: "/ats/benchsales/submissions",
//   //       id: "benchsalessubmission",
//   //     },
//   //     {
//   //       title: "Interviews",
//   //       link: "/ats/benchsales/interview",
//   //       id: "benchsalesinterview",
//   //     },
//   //      {
//   //       title: "Placements",
//   //       link: "/ats/benchsales/placements",
//   //       id: "benchsalesplacement",
//   //     },
//   //      /* {
//   //       title: "Pipeline",
//   //       link: "/ats/benchsales/kultfetch",
//   //       id: "benchsaleskultfetch",
//   //     },*/
//   //   ],
//   // },
//   {
//     icon: "badge",
//     title: "Reports",
//     link: "/ats/reports",
//     id: "reports",
//   },
//   {
//     icon: "storefront",
//     title: "Marketplace",
//     link: "/marketplace",
//     id: "marketplace",
//   },
// ];

// const SidebarNew = ({ isCollapsed, setIsCollapsed }) => {
//   const [showFullLogo, setShowFullLogo] = useState(false);
//   const { moduleAccess } = useSelector((state) => state.auth);
//   const { userData: loginUserData } = useLoginUser();
//   const navSettingLinks = [
//     {
//       icon: "category_search",
//       title: "Components List",
//       link: "/components-list",
//       id: "componentslist",
//     },
//     {
//       icon: "settings",
//       title: "Settings",
//       link: "/settings",
//       id: "settings",
//     },
//     {
//       icon: "help",
//       title: "Help",
//       link: "/ats/help",
//       id: "help",
//     },
//   ];
//   const filteredNav = filterNavByModuleAccess({
//     moduleAccess,
//     navData: atsNavLinkData,
//     role: loginUserData?.role?.type,
//   });
//   const filteredNavSettings = filterNavByModuleAccess({
//     moduleAccess,
//     navData: navSettingLinks,
//     role: loginUserData?.role?.type,
//   });
//   return (
//     <div className="bg-[#101A26] rounded-r-xl w-full h-screen text-white flex flex-col relative">
//       <div className="py-8 px-6 flex justify-center items-center">
//         <img
//           src={showFullLogo ? navHeaderLogo : navHeaderLogoIcon}
//           alt="Logo"
//           className={`transition-all duration-700 h-8 ${
//             showFullLogo ? "opacity-100 scale-100" : "opacity-100 scale-100"
//           }`}
//         />
//       </div>
//       <div className="flex-1 relative">
//         <SidebarMenuItems menus={filteredNav} menusEnd={filteredNavSettings} />
//       </div>
//     </div>
//   );
// };

// export default SidebarNew;

import React, { useEffect, useRef, useState } from "react";
import navHeaderLogo from "../../assets/sideBar/navHeaderLogo.svg";
import navHeaderLogoIcon from "../../assets/sideBar/navHeaderLogoIcon.svg";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLoginUser } from "../../hooks/useLoginUser";
import { filterNavByModuleAccess } from "../../utils/moduleAccessUtils";
import Divider from "./Divider";
import { createPortal } from "react-dom";

const SidebarMenuItems = ({ menus, menusEnd }) => {
  const [hoveredKey, setHoveredKey] = useState(null); // e.g. "top-2", "bottom-1"
  const [activeIndex, setActiveIndex] = useState(); // your existing active logic
  const [activeSubLink, setActiveSubLink] = useState();
  const [activeSubMenusLink, setActiveSubMenusLink] = useState();
  const [tooltip, setTooltip] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const closeTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    };
  }, []);

  // Onload set active index
  useEffect(() => {
    const path = location.pathname;
    const hashPath = location.pathname + location.hash;
    const items = [...(menus || []), ...(menusEnd || [])];

    for (const menu of items) {
      if (menu.link && (menu.link === path || menu.link === hashPath)) {
        setActiveIndex(menu.title);
        setActiveSubLink(undefined);
        return;
      }
      if (menu.subMenus) {
        for (const sub of menu.subMenus) {
          if (sub.link && (sub.link === path || sub.link === hashPath)) {
            setActiveIndex(menu.title);
            setActiveSubLink(sub.link);
            return;
          }
        }
      }
    }
  }, [location.pathname, location.hash, menus, menusEnd]);

  // Onload set active index end

  const decideDirection = (el, item) => {
    const rect = el.getBoundingClientRect();

    // Rough tooltip height estimate: title + items + padding
    const itemCount = item?.subMenus?.length || 0;
    const estimatedHeight = 20 /*title*/ + itemCount * 36 /*each*/ + 24; /*pad*/

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    // Prefer down unless it won't fit; then go up if we have more space above
    const needUp = spaceBelow < estimatedHeight && spaceAbove > spaceBelow;
    return needUp ? "up" : "down";
  };

  const handleMouseEnter = (e, section, index, item) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }

    const id = `${section}-${index}`;
    setHoveredKey(id);

    if (!item?.subMenus?.length) {
      setTooltip(null);
      return;
    }

    const direction = decideDirection(e.currentTarget, item);
    const rect = e.currentTarget.getBoundingClientRect();

    setTooltip({
      id,
      item,
      direction,
      left: rect.right,
      top: rect.top,
      bottom: window.innerHeight - rect.bottom,
    });
  };

  const closeTooltip = () => {
    setHoveredKey(null);
    setTooltip(null);
    setActiveSubMenusLink(undefined);
  };

  const handleMouseLeave = () => {
    if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    closeTimeoutRef.current = setTimeout(() => {
      closeTimeoutRef.current = null;
      closeTooltip();
    }, 120);
  };

  const handleMainMenu = (menu) => {
    if (!menu.subMenus && menu.link) {
      setActiveIndex(menu.title);
      setActiveSubLink(undefined);
      navigate(menu.link);
    }
  };

  const renderContent = (item, index, isActive, section) => {
    const id = `${section}-${index}`;
    const isHovered = hoveredKey === id;

    // Check if any submenu of THIS item is currently hovered
    const hasHoveredSubMenu = item.subMenus?.some(
      (sub) => sub.link === activeSubMenusLink,
    );

    return (
      <div key={id} className="w-full">
        <div
          className={`w-full flex flex-col items-center gap-1 py-3 group relative cursor-pointer ${
            isActive
              ? "bg-primary rounded-l-lg text-white"
              : hasHoveredSubMenu
                ? "bg-primary-50 text-black!"
                : "hover:bg-primary-50"
          }`}
          onMouseEnter={(e) => handleMouseEnter(e, section, index, item)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleMainMenu(item)}
        >
          <span
            className={`material-symbols-rounded text-[24px] font-thin ${
              isActive
                ? "text-white"
                : hasHoveredSubMenu
                  ? "text-black"
                  : "text-white group-hover:text-black"
            }`}
          >
            {item.icon}
          </span>
          <span
            className={`text-[10px] text-center font-normal ${
              isActive
                ? "text-white"
                : hasHoveredSubMenu
                  ? "text-black"
                  : "text-white group-hover:text-black"
            }`}
          >
            {item.abbrivation || item.title}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-0 h-full">
      <div className="flex-1">
        {menus.map((item, index) => {
          const isActive = activeIndex === item.title;
          return renderContent(item, index, isActive, "top");
        })}
      </div>

      {menusEnd?.map((item, index) => {
        const isActive = activeIndex === item.title;
        return renderContent(item, index, isActive, "bottom");
      })}

      {createPortal(
        <AnimatePresence>
          {tooltip && (
            <motion.div
              key={tooltip.id}
              initial={{
                opacity: 0,
                y: tooltip.direction === "up" ? 10 : -10,
              }}
              animate={{ opacity: 1, y: 0 }}
              exit={{
                opacity: 0,
                y: tooltip.direction === "up" ? 10 : -10,
              }}
              transition={{ duration: 0.2 }}
              className="fixed py-2 flex items-start rounded text-xs whitespace-nowrap z-[100]"
              style={{
                left: tooltip.left,
                top: tooltip.direction === "down" ? tooltip.top : "auto",
                bottom: tooltip.direction === "up" ? tooltip.bottom : "auto",
              }}
              onMouseEnter={() => {
                if (closeTimeoutRef.current) {
                  clearTimeout(closeTimeoutRef.current);
                  closeTimeoutRef.current = null;
                }
              }}
              onMouseLeave={() => {
                closeTooltip();
              }}
            >
              <div className="bg-[#101A26] text-white rounded-r-lg flex flex-col p-3 min-w-[180px] max-h-[70vh] overflow-auto">
                <h6>{tooltip.item.title}</h6>
                {tooltip.item.subMenus?.length > 0 && (
                  <>
                    <Divider className="text-primary my-1 w-[70%]" />
                    <div className="flex flex-col pt-2 ms-2">
                      {tooltip.item.subMenus.map((submenu, subKey) => (
                        <Link
                          key={`${tooltip.id}-sub-${subKey}`}
                          to={
                            submenu.link
                              ? submenu.link
                              : location.pathname + location.hash
                          }
                          onMouseEnter={() =>
                            setActiveSubMenusLink(submenu.link)
                          }
                          className={`py-2 hover:text-primary ${
                            activeSubLink === submenu.link
                              ? "text-primary font-medium"
                              : ""
                          }`}
                          onClick={() => {
                            setActiveIndex(tooltip.item.title);
                            setActiveSubLink(submenu.link);
                            closeTooltip();
                          }}
                        >
                          {submenu.title}
                        </Link>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body,
      )}
    </div>
  );
};

const atsNavLinkData = [
  {
    icon: "dashboard",
    title: "Dashboard",
    link: "/ats/dashboard",
    id: "dashboard",
  },
  {
    icon: "group_search",
    abbrivation: "RA",
    title: "Research Analyst",
    //link: "/ats/dashboard",
    subMenus: [
      {
        title: "Leads",
        link: "/ats/leads",
        id: "leads",
      },
      {
        title: "Campaigns",
        link: "/ats/campaigns",
        id: "campaigns",
      },
      {
        title: "Prospects",
        link: "/ats/prospects",
        id: "prospects",
      },
    ],
  },
  {
    icon: "host",
    abbrivation: "BDM/AM",
    title: "BDM/AM",
    //link: "/ats/leads",
    subMenus: [
      {
        title: "Accounts",
        link: "ats/account-details",
        id: "accountdetails",
      },
      {
        title: "Vendors",
        link: "/ats/vendors",
        id: "vendors",
      },
      {
        title: "Jobs",
        link: "/ats/jobs",
        id: "jobs",
      },
      {
        title: "Pipeline Candidate",
        link: "/ats/bdm/pipeline-candidates",
        id: "pipelinecandidates",
      },
      {
        title: "Client Submissions",
        link: "/ats/bdm/client-submissions",
        id: "clientsubmissions",
      },
      {
        title: "Follow up / interview",
        link: "/ats/bdm/followup-interviews",
        id: "followupinterviews",
      },
      {
        title: "Confirmed / Starts",
        link: "/ats/bdm/confirmed-starts",
        id: "confirmedstarts",
      },
      {
        title: "Priority Leads",
        link: "/ats/bdm/priority-leads",
        id: "priorityleads",
      },
    ],
  },
  {
    icon: "article_person",
    abbrivation: "Recruitment",
    title: "Recruitment",
    //link: "/ats/account-details",
    subMenus: [
      {
        title: "Jobs",
        link: "/ats/recruitment/jobs",
        id: "recruitmentjobs",
      },
      {
        title: "Sourcing",
        link: "/ats/applicants",
        id: "applicants",
      },
      {
        title: "Campaigns",
        link: "/ats/recruitment/campaigns",
        id: "recruitmentcampaigns",
      },
      {
        title: "Internal Submissions",
        link: "/ats/recruitment/internal-submissions",
        id: "recruitmentinternalsubmissions",
      },
      {
        title: "Interview follow-up",
        link: "/ats/recruitment/interview-followup",
        id: "recruitmentinterviewfollowup",
      },
      {
        title: "Confirmed / Starts",
        link: "/ats/recruitment/confirmed-start",
        id: "recruitmentconfirmedstart",
      },
    ],
  },
  // {
  //   icon: "badge",
  //   abbrivation: "Bench Sales",
  //   title: "Bench Sales",
  //   //link: "/ats/campaigns",
  //   subMenus: [
  //        {
  //       title: "Recruiters",
  //       link: "/ats/benchsales/recruiters",
  //       id: "benchsalesrecruiters",
  //     },
  //     {
  //       title: "Candidates",
  //       link: "/ats/benchsales/candidates",
  //       id: "benchsaleshotlist",
  //     },
  //   /*  {
  //     title: "Campaign",
  //       link: "/ats/benchsales/campaign",
  //       id: "benchsalescampaign",
  //     },*/
  //     {
  //       title: "Jobs",
  //       link: "/ats/benchsales/Jobs",
  //       id: "benchsaleskultfetch",
  //     },
  //     {
  //       title: "Submissions",
  //       link: "/ats/benchsales/submissions",
  //       id: "benchsalessubmission",
  //     },
  //     {
  //       title: "Interviews",
  //       link: "/ats/benchsales/interview",
  //       id: "benchsalesinterview",
  //     },
  //      {
  //       title: "Placements",
  //       link: "/ats/benchsales/placements",
  //       id: "benchsalesplacement",
  //     },
  //      /* {
  //       title: "Pipeline",
  //       link: "/ats/benchsales/kultfetch",
  //       id: "benchsaleskultfetch",
  //     },*/
  //   ],
  // },
  {
    icon: "badge",
    title: "Reports",
    link: "/ats/reports",
    id: "reports",
  },
  {
    icon: "storefront",
    title: "Marketplace",
    link: "/marketplace",
    id: "marketplace",
  },
];

const SidebarNew = ({ isCollapsed, setIsCollapsed }) => {
  const [showFullLogo, setShowFullLogo] = useState(false);
  const { moduleAccess } = useSelector((state) => state.auth);
  const { userData: loginUserData } = useLoginUser();
  const navSettingLinks = [
    {
      icon: "category_search",
      title: "Components List",
      link: "/components-list",
      id: "componentslist",
    },
    {
      icon: "settings",
      title: "Settings",
      link: "/settings",
      id: "settings",
    },
    {
      icon: "help",
      title: "Help",
      link: "/ats/help",
      id: "help",
    },
  ];
  const filteredNav = filterNavByModuleAccess({
    moduleAccess,
    navData: atsNavLinkData,
    role: loginUserData?.role?.type,
  });
  const filteredNavSettings = filterNavByModuleAccess({
    moduleAccess,
    navData: navSettingLinks,
    role: loginUserData?.role?.type,
  });
  return (
    <div className="bg-[#101A26] rounded-r-xl w-full h-full text-white flex flex-col relative">
      <div className="py-8 px-6 flex justify-center items-center">
        <img
          src={showFullLogo ? navHeaderLogo : navHeaderLogoIcon}
          alt="Logo"
          className={`transition-all duration-700 h-8 ${
            showFullLogo ? "opacity-100 scale-100" : "opacity-100 scale-100"
          }`}
        />
      </div>
      <div className="flex-1 relative overflow-x-hidden overflow-y-auto">
        <SidebarMenuItems menus={filteredNav} menusEnd={filteredNavSettings} />
      </div>
    </div>
  );
};

export default SidebarNew;
